export default __webpack_public_path__ + "static/5-754d592b9fc71bdd0e1daa15682dd167.jpeg";